export default function isLoggedIn(value) {
  if (!value) {
    return false;
  }

  return value.id !== undefined;
}
